import React from 'react';
import Version1 from './Version1';
import Version2 from './Version2';

const View = ({ version, data }) => {
  if (version === 1) return <Version1 item={data} />;
  if (version === 2) return <Version2 item={data} />;

  return <div>Unknown version</div>;
};

View.propTypes = {};

export default View;
